import { For, Show } from 'solid-js';
import { DropdownOption, FieldType, FormFieldContext } from '../forms-types';
import { FieldErrorMessage } from './primitives';
import { Checkbox } from '../../../ui-components/inputs/checkbox/checkbox';
import { Radio } from '../../../ui-components/inputs/radio/radio';
import { VerticalSpace } from '../../../ui-components/utility-style-components/spacing';
import { Heading } from '../../../ui-components/heading/heading';
import { parseFieldOptions } from '../utils';

type FieldProps = {
    field: FieldType;
    ctx: FormFieldContext;
};

export const RadioButtons = (props: FieldProps) => {
    const { formValues, errors, onRadioChange } = props.ctx;

    const extraSettings = () => props.field.extraSettings;
    const required = () => props.field.required;
    const eloquaName = () => extraSettings()?.name.value ?? '';
    const placeholder = () => required() ? extraSettings()!.placeholder.value + '*' : extraSettings()?.placeholder.value ?? '';
    const options = (): DropdownOption[] => parseFieldOptions(extraSettings()?.options.value ?? '');

    return (
        <Show when={extraSettings()}>
            <div>
                <VerticalSpace size={1} />
                <Heading tag="h4" variant="temporarySmall">{placeholder()}</Heading>
                <ul>
                    <For each={options()}>
                        {(option, i) => (
                            <li>
                                <Radio
                                    whenClicked={() => onRadioChange(eloquaName(), option.value)}
                                    value={option.value}
                                    readableName={option.text}
                                    isChecked={formValues()[eloquaName()] === option.value}
                                    name={'custom-radio-' + eloquaName()}
                                    id={`radio-${option.value}-${i()}`}
                                    aria-label={option.text}
                                    aria-describedby={`desc-${eloquaName()}`}
                                    title={placeholder()}
                                />
                            </li>
                        )}
                    </For>
                </ul>
                <span id={`desc-${eloquaName()}`} style={{ display: 'none' }}>{placeholder()}</span>
                <Show when={errors()[eloquaName()]}>
                    <FieldErrorMessage errors={errors} fieldKey={eloquaName()} />
                </Show>
            </div>
        </Show>
    );
};

export const CheckboxGroup = (props: FieldProps) => {
    const { formValues, errors, onCheckboxChange } = props.ctx;

    const extraSettings = () => props.field.extraSettings;
    const required = () => props.field.required;
    const eloquaName = () => extraSettings()?.name.value ?? '';
    const placeholder = () => required() ? extraSettings()!.placeholder.value + '*' : extraSettings()?.placeholder.value ?? '';
    const options = (): DropdownOption[] => parseFieldOptions(extraSettings()?.options.value ?? '');
    const selectedValues = () => (formValues()[eloquaName()] ?? '').split(',').filter(Boolean);

    return (
        <Show when={extraSettings()}>
            <div>
                <VerticalSpace size={1} />
                <Heading tag="h4" variant="temporarySmall">{placeholder()}</Heading>
                <ul>
                    <For each={options()}>
                        {(option, i) => (
                            <li>
                                <Checkbox
                                    isChecked={selectedValues().includes(option.value)}
                                    whenClicked={(e: any) => onCheckboxChange(eloquaName(), option.value, e.target.checked)}
                                    value={option.value}
                                    name={option.text}
                                    inputName={'custom-checkbox-' + eloquaName()}
                                    id={`checkbox-${option.value}-${i()}`}
                                    aria-label={option.text}
                                    aria-describedby={`desc-${eloquaName()}`}
                                    title={placeholder()}
                                />
                            </li>
                        )}
                    </For>
                </ul>

                <span id={`desc-${eloquaName()}`} style={{ display: 'none' }}>
                    {placeholder()}
                </span>

                <Show when={errors()[eloquaName()]}>
                    <FieldErrorMessage errors={errors} fieldKey={eloquaName()} />
                </Show>
            </div>
        </Show>
    );
};
